import React, { useEffect, useState } from "react";
import PageLayout from "../../../PageLayout";
import { EButton, ELabelView, EPageTitle, ESectionDivider } from "../../../libs/ui";
import SurveyGroup from "./SurveyGroup";
import { Button, Grid } from "@mantine/core";
import { BiLeftArrow } from "react-icons/bi";
import moment from "moment";

const SchoolSurveyQuestions = ({
  surveyDetails,
  districts,
  setSurveyQuestionEnable,
  handleSave,
  handleUpdateAnswer,
  questionGroups,
}: any) => {
  return (
    <>
      <EPageTitle
        title="Survey"
        end={
          <Button
            leftIcon={<BiLeftArrow />}
            className="btn-blue"
            onClick={() => setSurveyQuestionEnable(false)}
          >
            Back
          </Button>
        }
      />
      <div>
        <Grid>
          <Grid.Col span={4}>
            <ELabelView
              label="Title"
              value={surveyDetails?.survey_Title ?? " - "}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            {surveyDetails?.survey_Description ? (
              <ELabelView
                label="Description"
                value={surveyDetails?.survey_Description || " - "}
              />
            ) : (
              ""
            )}
          </Grid.Col>
          <Grid.Col span={4}>
            <ELabelView
              label="Date Range"
              value={`${
                surveyDetails?.survey_Start_Date
                  ? moment(surveyDetails?.survey_Start_Date).format(
                      "DD-MM-YYYY",
                    )
                  : "DD/MM/YYYY"
              }
                   to 
                   ${surveyDetails?.survey_End_Date ? moment(surveyDetails?.survey_End_Date).format("DD-MM-YYYY") : "DD/MM/YYYY"}
                   `}
            />
          </Grid.Col>
        </Grid>
        <Grid className="mt-3 mb-3">
          <Grid.Col span={4}>
            <ELabelView
              label="Districts"
              value={
                districts
                  ?.filter((e: any) =>
                    surveyDetails?.district_Id?.includes(String(e?.id)),
                  )
                  .map((e: any) => e?.name)
                  .join(", ") || " - "
              }
            />
          </Grid.Col>
        </Grid>
      </div>
      <div className="p-4 flex flex-col gap-6">
        <ESectionDivider title="Questions" />
        {questionGroups.map((group: any, groupIndex: any) => (
          <SurveyGroup
            key={groupIndex}
            group={group}
            groupIndex={groupIndex}
            onAnswerChange={handleUpdateAnswer}
          />
        ))}

        <div className="flex justify-end">
          <EButton className="btn-blue" onClick={handleSave}>
            Submit
          </EButton>
        </div>
      </div>
    </>
  );
};

export default SchoolSurveyQuestions;
